import React from 'react';

export enum ECommonQuestionsRoutes {
  ACCESS_MANAGEMENT = '/access-management',
  CONTRACTS_AND_CONSTRUCTIONS = '/contracts-constructions',
  DOWNLOAD_AREA = '/download-area',
  ORDERS = '/orders',
  PURCHASE = '/purchase',
  FINANCIALS = '/financials'
}
export interface IQuestionAnswerPage {
  title: string;
  route: ECommonQuestionsRoutes;
  questions: { question: string; answer: JSX.Element }[];
  tagItemName: string;
  tagItemDescription: string;
}

export const allQuestionAnswer: IQuestionAnswerPage[] = [
  {
    title: 'Gestão de usuário',
    route: ECommonQuestionsRoutes.ACCESS_MANAGEMENT,
    tagItemName: 'expandable_card:gestao_usuario',
    tagItemDescription: 'ajuda_perguntasFrequentes_gestaoUsuario',
    questions: [
      {
        question: 'Como cadastrar um novo usuário?',
        answer: (
          <>
            Acessando a funcionalidade de gestão de usuários que fica localizada
            no menu superior direito, clicando no nome do usuário, selecione a
            opção adicionar usuário, preencha as informações solicitadas e
            selecionando as permissões do usuário.
          </>
        )
      },
      {
        question: 'Como alterar permissões de usuário?',
        answer: (
          <>
            Acessando a funcionalidade de gestão de usuários que fica localizada
            no menu superior direito, clicando no nome do usuário, escolha a
            empresa e o usuário que deseja alterar. Após isso, edite as
            permissões do usuário.
          </>
        )
      }
    ]
  },
  {
    title: 'Contratos e obras',
    route: ECommonQuestionsRoutes.CONTRACTS_AND_CONSTRUCTIONS,
    tagItemName: 'expandable_card:contratos_e_obras',
    tagItemDescription: 'ajuda_perguntasFrequentes_contratosEObras',
    questions: [
      {
        question: 'Meu contrato não aparece no Gerdau mais, o que fazer?',
        answer: (
          <>
            Altere o perfil de visualização no menu superior, clicando no nome
            do usuário, alterando para visão de emissor. Caso o contrato
            continue não aparecendo, entre em contato com o seu vendedor para
            consultar o status de liberação do mesmo.
          </>
        )
      },
      {
        question: 'Como alterar dados do meu contrato?',
        answer: (
          <>
            Ainda não é possível alterar dados do contrato no Gerdau mais. Para
            realizar a alteração, entre em contato com o seu vendedor ou com
            nossa central de atendimento via e-mail:{' '}
            <a
              href="mailto:suportegerdaumais@gerdau.com.br"
              title="mailto:suportegerdaumais@gerdau.com.br"
              data-renderer-mark="true"
            >
              suportegerdaumais@gerdau.com.br
            </a>{' '}
            ou através do número: 0800 722 3322.
          </>
        )
      }
    ]
  },
  {
    title: 'Buscar documentos',
    route: ECommonQuestionsRoutes.DOWNLOAD_AREA,
    tagItemName: 'expandable_card:buscar_documentos',
    tagItemDescription: 'ajuda_perguntasFrequentes_buscarDocumentos',
    questions: [
      {
        question:
          'Por que o certificado de qualidade não está disponível para alguns produtos?',
        answer: (
          <>
            Ainda não conseguimos disponibilizar o Certificado de qualidade de
            algumas de nossas unidades via Gerdau mais. No caso de Certificado
            de Qualidade indisponível, entre em contato com o vendedor ou com
            nossa central de atendimento via e-mail:{' '}
            <a
              href="mailto:suportegerdaumais@gerdau.com.br"
              title="mailto:suportegerdaumais@gerdau.com.br"
              data-renderer-mark="true"
            >
              suportegerdaumais@gerdau.com.br
            </a>{' '}
            ou através do número: 0800 722 3322 para envio do mesmo.
          </>
        )
      },
      {
        question: 'Não consigo baixar a 2ª via do boleto, o que fazer?',
        answer: (
          <>
            Verifique se o pedido já foi faturado, caso o mesmo já tenha sido e
            a 2ª via do boleto não esteja disponível, entre em contato com o
            vendedor ou com nossa central de atendimento via e-mail:{' '}
            <a
              href="mailto:suportegerdaumais@gerdau.com.br"
              title="mailto:suportegerdaumais@gerdau.com.br"
              data-renderer-mark="true"
            >
              suportegerdaumais@gerdau.com.br
            </a>{' '}
            ou através do número: 0800 722 3322 para solicitar a 2ª via do
            boleto.
          </>
        )
      }
    ]
  },
  {
    title: 'Pedidos',
    route: ECommonQuestionsRoutes.ORDERS,
    tagItemName: 'expandable_card:pedidos',
    tagItemDescription: 'ajuda_perguntasFrequentes_pedidos',
    questions: [
      {
        question: 'Como revisar meu pedido de corte e dobra?',
        answer: (
          <>
            Para realizar a revisão do seu pedido Corte e Dobra, você precisa ir
            em Recompra de Pedido, selecionar o pedido que deseja fazer revisão
            e realizar a revisão.
          </>
        )
      }
    ]
  },
  {
    title: 'Compras',
    route: ECommonQuestionsRoutes.PURCHASE,
    tagItemName: 'expandable_card:gestao_compras',
    tagItemDescription: 'ajuda_perguntasFrequentes_compras',
    questions: [
      {
        question: 'Por que não consigo localizar um produto?',
        answer: (
          <>
            <p>Existem alguns motivos para um produto não ser encontrado:</p>
            <ul style={{ paddingInlineStart: '2.5rem' }}>
              <li>
                <p>Descrição do produto está errada;</p>
              </li>
              <li>
                <p>Produto não faz parte do seu grupo de compra;</p>
              </li>
              <li>
                <p>O código está errado;</p>
              </li>
              <li>
                <p>
                  Opção de qual código utilizar (Gerdau ou Código Interno) está
                  errado.
                </p>
              </li>
            </ul>
          </>
        )
      },
      {
        question: 'Erro ao comprar utilizando planilha, o que fazer?',
        answer: (
          <>
            Verifique se sua planilha está de acordo com a configuração da
            planilha esperada no Gerdau mais.
          </>
        )
      }
    ]
  },
  {
    title: 'Finanças',
    route: ECommonQuestionsRoutes.FINANCIALS,
    tagItemName: 'expandable_card:gestao_financas',
    tagItemDescription: 'ajuda_perguntasFrequentes_financas',
    questions: [
      {
        question:
          'Não consigo fazer download da 2o via de boleto, o que fazer?',
        answer: (
          <>
            Verifique se o pedido já foi faturado, caso o mesmo já tenha sido e
            a 2ª via do boleto não esteja disponível, entre em contato com o
            vendedor ou com nossa central de atendimento via e-mail:{' '}
            <a
              href="mailto:suportegerdaumais@gerdau.com.br"
              title="mailto:suportegerdaumais@gerdau.com.br"
              data-renderer-mark="true"
            >
              suportegerdaumais@gerdau.com.br
            </a>{' '}
            ou através do número: 0800 722 3322 para solicitar a 2ª via do
            boleto.
          </>
        )
      }
    ]
  }
];
